import { v4 as uuidv4 } from 'uuid';
export class GuidService {
  static getGuid(): string {
    return uuidv4();
  }
}

export const Available = (ready: boolean) => {
  const action = ready ? 'Ready' : 'DoNotDisturb';
  let sb = '';
  sb += 'Request: Available\n';
  sb += 'RequestId: available_' + GuidService.getGuid() + '\n';
  sb += 'Action: ' + action + '\n';
  sb += '\n';
  return sb;
};

export const BlindTransfer = (telephone: string, call_id: string) => {
  let sb = '';
  sb += 'Request: CallAction\n';
  sb += 'RequestId: blindTransfer_' + GuidService.getGuid() + '\n';
  sb += 'Action: BlindTransfer\n';
  sb += 'ContactNumber: ' + telephone + '\n';
  sb += 'CallId: ' + call_id + '\n';
  sb += '\n';
  return sb;
};

export const BreakStart = (type: string) => {
  let sb = '';
  sb += 'Request: Break\n';
  sb += 'RequestId: break-start_' + GuidService.getGuid() + '\n';
  sb += 'Action: Start\n';
  sb += 'BreakType: DND-' + type.toUpperCase() + '\n';
  sb += '\n';
  return sb;
};

export const BreakStop = () => {
  let sb = '';
  sb += 'Request: Break\n';
  sb += 'RequestId: break-stop_' + GuidService.getGuid() + '\n';
  sb += 'Action: Stop\n';
  sb += '\n';
  return sb;
};

export const Conference = (call_id: string) => {
  let sb = '';
  sb += 'Request: CallAction\n';
  sb += 'RequestId: conference_' + GuidService.getGuid() + '\n';
  sb += 'Action: Conference\n';
  sb += 'CallId: ' + call_id + '\n';
  sb += '\n';
  return sb;
};

export const ContactLookup = (
  field: string,
  value: string,
  limitStart: string,
  limitQuantity: string
) => {
  let sb = '';
  sb += 'Request: ContactLookup\n';
  sb += 'RequestId: lookup_' + GuidService.getGuid() + '\n';
  sb += 'Field: ' + field + '\n';
  sb += 'Value: ' + value + '\n';
  sb += 'LimitStart: ' + limitStart + '\n';
  sb += 'LimitQuantity: ' + limitQuantity + '\n';
  sb += '\n';
  return sb;
};

export const ContactLookupByContactID = (contactId: string) => {
  let sb = '';
  sb += 'Request: ContactLookup\n';
  sb += 'RequestId: lookup_' + GuidService.getGuid() + '\n';
  sb += 'ContactId: ' + contactId + '\n';
  sb += '\n';

  return sb;
};

export const Dial = (
  telephone: string,
  profile_id: string,
  call_type: string,
  contact?: string,
  countryCode?: string
) => {
  const request = call_type.length > 0 ? call_type.toLowerCase() : 'dial';

  let sb = '';
  sb += 'Request: Dial\n';
  sb += 'RequestId: ' + request + '_' + GuidService.getGuid() + '\n';
  if (telephone) {
    sb += 'ContactNumber: ' + telephone + '\n';
  }
  if (profile_id) {
    sb += 'ProfileId: ' + profile_id + '\n';
  }
  if (contact) {
    sb += 'ContactId: ' + contact + '\n';
  }
  sb += 'CallType: ' + call_type + '\n';
  sb += 'CountryCode: ' + (countryCode ?? '+1') + '\n';
  sb += '\n';
  return sb;
};

export const DialTransfer = (
  telephone: string,
  profile_id: string,
  transfer_profile_id: string,
  call_type: string,
  dial_type: string,
  contact: string,
  countryCode: string
) => {
  const request = call_type.length > 0 ? call_type.toLowerCase() : 'dial';

  let sb = '';
  sb += 'Request: Dial\n';
  sb += 'RequestId: ' + request + '_' + GuidService.getGuid() + '\n';
  if (telephone) {
    sb += 'ContactNumber: ' + telephone + '\n';
  }
  if (profile_id) {
    sb += 'ProfileId: ' + profile_id + '\n';
  }
  if (contact) {
    sb += 'TransferAgentId: ' + contact + '\n';
  }
  if (transfer_profile_id) {
    sb += 'TransferProfileId: ' + transfer_profile_id + '\n';
  }
  sb += 'CallType: ' + call_type + '\n';
  sb += 'DialType: ' + dial_type + '\n';
  sb += 'CountryCode: ' + (countryCode ?? '+1') + '\n';
  sb += '\n';
  return sb;
};

export const EndCall = (
  call_id: string,
  disposition: string,
  callback_date: string,
  callback_telephone: string,
  isTransfer?: boolean,
  conf_call_id?: string,
  transfer_call_id?: string
) => {
  let sb = '';
  sb += 'Request: CallAction\n';
  sb += 'RequestId: endcall_' + GuidService.getGuid() + '\n';
  sb += 'Action: EndCall\n';
  sb += 'CallId: ' + call_id + '\n';
  sb += 'ConferenceCallId: ' + conf_call_id + '\n';
  sb += 'TransferCallId: ' + transfer_call_id + '\n';
  sb += 'CallDisposition: ' + disposition + '\n';
  sb += 'CallbackDate: ' + callback_date + '\n';
  sb += 'CallbackTelephone: ' + callback_telephone + '\n';
  sb += 'AgentcallTransferStatus: ' + (isTransfer ? 'true' : 'false') + '\n';
  sb += '\n';
  return sb;
};

export const WrapUpEndCall = (
  call_id: string,
  disposition: string,
  callback_date: string,
  callback_telephone: string,
  isTransfer?: boolean,
  conf_call_id?: string
) => {
  let sb = '';
  sb += 'Request: CallAction\n';
  sb += 'RequestId: endcall_' + GuidService.getGuid() + '\n';
  sb += 'Action: EndCallForWrapup\n';
  sb += 'CallId: ' + call_id + '\n';
  sb += 'ConferenceCallId: ' + conf_call_id + '\n';
  sb += 'CallDisposition: ' + disposition + '\n';
  sb += 'CallbackDate: ' + callback_date + '\n';
  sb += 'CallbackTelephone: ' + callback_telephone + '\n';
  sb += 'AgentcallTransferStatus: ' + (isTransfer ? 'true' : 'false') + '\n';
  sb += '\n';
  return sb;
};

export const Hangup = (call_id: string, isTransfer?: boolean) => {
  let sb = '';
  sb += 'Request: CallAction\n';
  sb += 'RequestId: hangup_' + GuidService.getGuid() + '\n';
  sb += 'Action: Hangup\n';
  sb += 'CallDisposition: Custom\n';
  sb += 'CallbackDate: \n';
  sb += 'CallbackTelephone: \n';
  sb += 'CallId: ' + call_id + '\n';
  sb += 'AgentcallTransferStatus: ' + (isTransfer ? 'true' : 'false') + '\n';
  sb += '\n';
  return sb;
};

export const Hold = (call_id: string, agent_id?: string) => {
  let sb = '';
  sb += 'Request: CallAction\n';
  sb += 'RequestId: hold_' + GuidService.getGuid() + '\n';
  sb += 'Action: Hold\n';
  sb += 'CallId: ' + call_id + '\n';
  sb += 'AgentId: ' + agent_id + '\n';
  sb += '\n';
  return sb;
};

export const Login = (user: string, pass: string, skipAoaCall: string) => {
  let sb = '';
  sb += `Request: Login\n`;
  sb += `RequestId: login_${GuidService.getGuid()}\n`;
  sb += `User: ${user}\n`;
  sb += `Password: ${pass}\n`;
  sb += `UserScreenType: H5A\n`;
  sb += `SkipAoaCall: ${skipAoaCall}\n`;
  return sb;
};

export const Logoff = () => {
  let sb = '';
  sb += 'Request: Logoff\n';
  sb += 'RequestId: logoff_' + GuidService.getGuid() + '\n';
  sb += '\n';
  return sb;
};
export const Logout = () => {
  let sb = '';
  sb += 'Request: Logout\n';
  sb += '\n';

  return sb;
};
export const LoginSimulated = (user: string, pass: string, pots: string) => {
  let sb = '';
  sb += 'Request: Login\n';
  sb += 'RequestId: login_' + GuidService.getGuid() + '\n';
  sb += 'User: ' + user + '\n';
  sb += 'Password: ' + pass + '\n';
  sb += 'PotsNumber: ' + pots + '\n';
  sb += 'UserScreenType: SIMULATED\n';
  sb += '\n';
  return sb;
};

export const SipInfo = () => {
  let sb = '';
  sb += 'Request: SipInfo\n';
  sb += '\n';
  return sb;
};
export const Ping = (user: string) => {
  let sb = '';
  sb += 'Ping: ' + user + '\n';

  return sb;
};

export const ReceiveReady = (ready: boolean) => {
  const readyVerb = ready ? 'Ready' : 'DoNotDisturb';

  let sb = '';
  sb += 'Request: ReceiveReady\n';
  sb += 'RequestId: receiveready_' + GuidService.getGuid() + '\n';
  sb += 'Action: ' + readyVerb + '\n';
  sb += '\n';

  return sb;
};

export const UserInfoByType = (info_type: string) => {
  let sb = '';
  sb += 'Request: Info\n';
  sb += 'RequestId: ' + info_type + '_' + GuidService.getGuid() + '\n';
  sb += 'InfoType: ' + info_type + '\n';
  sb += '\n';
  return sb;
};

export const NonQuery = (
  command: string,
  tenantId: string,
  bHasCallback: string
) => {
  let sb = '';
  sb += 'Request: NonQuery\n';
  sb += 'RequestId: non_query_' + GuidService.getGuid() + '\n';
  sb += 'TenantId: ' + tenantId + '\n';
  sb += 'Command: ' + command + '\n';
  sb += 'HasCallBack: ' + bHasCallback + '\n';
  sb += '\n';

  return sb;
};

export const RecordStart = (call_id: string) => {
  let sb = '';
  sb += 'Request: CallAction\n';
  sb += 'RequestId: record-start_' + GuidService.getGuid() + '\n';
  sb += 'Action: RecordStart\n';
  sb += 'CallId: ' + call_id + '\n';
  sb += '\n';

  return sb;
};
export const RecordPause = (call_id: string) => {
  let sb = '';
  sb += 'Request: CallAction\n';
  sb += 'RequestId: record-pause_' + GuidService.getGuid() + '\n';
  sb += 'Action: RecordPause\n';
  sb += 'CallId: ' + call_id + '\n';
  sb += '\n';

  return sb;
};
export const RecordResume = (call_id: string) => {
  let sb = '';
  sb += 'Request: CallAction\n';
  sb += 'RequestId: record-resume_' + GuidService.getGuid() + '\n';
  sb += 'Action: RecordResume\n';
  sb += 'CallId: ' + call_id + '\n';
  sb += '\n';

  return sb;
};

export const RecordStop = (call_id: string) => {
  let sb = '';
  sb += 'Request: CallAction\n';
  sb += 'RequestId: record-stop_' + GuidService.getGuid() + '\n';
  sb += 'Action: RecordStop\n';
  sb += 'CallId: ' + call_id + '\n';
  sb += '\n';

  return sb;
};

export const Resume = (
  call_id: string,
  hangupTransferCall?: boolean,
  agent_id?: string
) => {
  let sb = '';
  sb += 'Request: CallAction\n';
  sb += 'RequestId: resume_' + GuidService.getGuid() + '\n';
  sb += 'Action: Resume\n';
  sb += 'CallId: ' + call_id + '\n';
  sb += 'AgentId: ' + agent_id + '\n';
  sb += 'HangupTransferCall: ' + (hangupTransferCall ? 'true' : 'false') + '\n';
  sb += '\n';

  return sb;
};

export const Transfer = (call_id: string, isDropMyself: boolean, transferProfileId?: string) => {
  let sb = '';
  sb += 'Request: CallAction\n';
  sb += 'RequestId: transfer_' + GuidService.getGuid() + '\n';
  sb += 'Action: Transfer\n';
  sb += 'CallId: ' + call_id + '\n';
  if (transferProfileId) {
    sb += 'TransferProfileId: ' + transferProfileId + '\n';
  }
  if (isDropMyself) {
    sb += 'DropMyself: true\n';
  }
  sb += '\n';

  return sb;
};

export const previewManualCancel = () => {
  let sb = '';
  sb += 'Request: PreviewManual\n';
  sb += 'RequestId: preview-manual-cancel_' + GuidService.getGuid() + '\n';
  sb += 'Action: Cancel\n';
  sb += '\n';

  return sb;
};

export const previewManualDial = () => {
  let sb = '';
  sb += 'Request: PreviewManual\n';
  sb += 'RequestId: preview-manual-dial_' + GuidService.getGuid() + '\n';
  sb += 'Action: Dial\n';
  sb += '\n';

  return sb;
};
